import React, { Component } from 'react';
import { CircularProgress } from '@material-ui/core';
import '../styles/Loading_Style.css';

class Spinner extends Component {
    render() {
        return (
            <div id="bg-spinner">
                <CircularProgress color="inherit" id="load-spinner" />
            </div>
        )
    }
}

export default Spinner;